// env.js
export const isProd = process.env.NODE_ENV === "production";
